import React from "react";
import "../../Styles/EmtiyazBashgah.css";
import Page from "../Page/Page";
import ModalCS from "../../Components/componentBashgah/ModalCS";
import ModalHelpCS from "../../Components/componentBashgah/ModalHelpCS";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import {
  Transaction_Club,
  Transaction_Profile,
} from "../../Connections/Transaction";
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import PictureProfile from "../../Containers/Profile/PictureProfile";

const EmtiyazBashgah = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const { from } = location.state;
  //  ==================================================

  const [showHistory, setShowHistory] = useState(true);

  const [myScoreList, setMyScoreList] = useState([]);
  const [scoreHelpList, setScoreHelpList] = useState([]);

  const [user, setUser] = useState({});

  //  ==================================================

  useEffect(() => {
    Transaction_Club.GetMyScores()
      .then((res) => {
        if (res[0]) {
          setMyScoreList(res[2].data);
        }
      })
      .catch((err) => console.log(err));

    Transaction_Club.GetScoreHelps()
      .then((res) => {
        if (res[0]) {
          setScoreHelpList(res[2].data);
          console.log(res[2].data);
        }
      })
      .catch((err) => console.log(err));

    Transaction_Profile.GetProfile()
      .then((res) => {
        if (res[0]) {
          setUser(res[2].data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  //  ==================================================

  return (
    <Page>
      <MobileNavBar text={"امتیازهای من"} action={() => navigator(-1)} />
      <div className="mobile-hidden">
        <div className="EmtiyazBashgah">
          <div
            className="EmtiyazBashgah_back-arrow mobile-hidden"
            onClick={() => navigator(-1)}
          >
            <svg
              width="8"
              height="15"
              viewBox="0 0 8 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
                fill="#ffffff"
              />
            </svg>
          </div>
          <div className="EmtiyazBashgah-inside">
            <div className="EmtiyazBashgah-inside-item1 mobile-hidden">
              <div className="EmtiyazBashgah-inside-item1-reght">
                <div className="EmtiyazBashgah-inside-item1-reght-text">
                  <p className="EmtiyazBashgah-inside-item1-reght-name">
                    {user.name?.length > 2 ? user.name : "کاربر"}
                  </p>
                  <p className="EmtiyazBashgah-inside-item1-reght-number number-font">
                    {user.mobile}
                  </p>
                </div>
              </div>
              <div className="EmtiyazBashgah-inside-item1-left">
                <div className="Bashgah-inside-item1-left">
                  <div className="Profile-top">
                    <div className="Profile-top-right">
                      <div className="Profile-top-right-inside">
                        <div className="Profile-top-right-inside-text">
                          {/* <div className="Profile-top-right-inside-text-display">
                        <p
                          className="Profile-top-right-inside-text-name"
                          style={{ textAlign: "center" }}
                        >
                          {user.name || "کاربر"}
                        </p>
                        <p className="Profile-top-right-inside-text-phone number-font">
                          {user.mobile}
                        </p>
                      </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="Profile-top-left">
                      <PictureProfile
                        profileSrc={user.avatar}
                        iconChange={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {localStorage.getItem("Token") && myScoreList.length > 0 ? (
              <div className="EmtiyazBashgah-inside-item2">
                <div className="EmtiyazBashgah-inside-item2-top mobile-hidden">
                  <div className="EmtiyazBashgah-inside-item2-top-border">
                    <p className="EmtiyazBashgah-inside-item2-top-border-title">
                      تاریخچه امتیاز
                    </p>
                  </div>
                </div>
                <div className="EmtiyazBashgah-inside-item2-bottom">
                  <Swiper
                    spaceBetween={20}
                    // breakpoints={{
                    //   640: { slidesPerView: 3 },
                    //   992: { slidesPerView: 4 },
                    //   1300: {
                    //     slidesPerView: myScoreList.length,
                    //   },
                    // }}
                    breakpoints={{
                      1440: {
                        slidesPerView: 5,
                      },
                      1300: {
                        slidesPerView: 4,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                      1100: {
                        slidesPerView: 3,
                      },
                      992: {
                        slidesPerView: 3,
                      },
                      900: {
                        slidesPerView: 2.9,
                      },
                      800: {
                        slidesPerView: 2.75,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                    }}
                    slidesPerView={2}
                  >
                    {myScoreList.map((item, i) => (
                      <SwiperSlide key={i}>
                        <ModalCS
                          img={"/imgs/Bashgah/bashgah-almas.svg"}
                          title={`${item.numberOfScore} امتیاز`}
                          time={item.date}
                          text={item.description}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            ) : null}

            <div className="EmtiyazBashgah-inside-item3">
              <div className="EmtiyazBashgah-inside-item3-top mobile-hidden">
                <div className="EmtiyazBashgah-inside-item3-top-border">
                  <p className="EmtiyazBashgah-inside-item3-top-border-title">
                    راهنمای دریافت امتیاز
                  </p>
                </div>
              </div>
              <div className="EmtiyazBashgah-inside-item3-bottom">
                <Swiper
                  spaceBetween={20}
                  breakpoints={{
                    640: { slidesPerView: 2 },
                    992: { slidesPerView: 3 },
                    1300: { slidesPerView: 4 },
                  }}
                  slidesPerView={1.5}
                >
                  {scoreHelpList.map((item, i) => (
                    <SwiperSlide key={i}>
                      <ModalHelpCS
                        img={"/imgs/Bashgah/bashgah-almas.svg"}
                        title={`${item.numberOfScore} امتیاز`}
                        text={item.description}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="desktop-hidden-block" style={{ display: "block" }}>
        <div className="EmtiyazBashgah-res">
          <div className="EmtiyazBashgah-res-inside">
            <div
              className={`EmtiyazBashgah-res-inside-right ${
                showHistory ? "active" : ""
              }`}
              onClick={() => setShowHistory(true)}
            >
              <p className="EmtiyazBashgah-res-inside-right-text">
                تاریخچه امتیاز
              </p>
            </div>
            <div
              className={`EmtiyazBashgah-res-inside-left ${
                showHistory ? "" : "active"
              }`}
              onClick={() => setShowHistory(false)}
            >
              <p className="EmtiyazBashgah-res-inside-left-text">
                راهنمای دریافت امتیاز
              </p>
            </div>
          </div>
        </div>
        {showHistory ? (
          <div className="EmtiyazBashgah-inside-item2-bottom">
            {myScoreList.length > 0 ? (
              myScoreList.map((item) => (
                <ModalCS
                  img={"/imgs/Bashgah/bashgah-almas.svg"}
                  title={`${item.numberOfScore} امتیاز`}
                  time={item.date}
                  text={item.description}
                />
              ))
            ) : (
              <div className="EmtiyazBashgah-inside-item2-bottom-no-coin">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="57"
                  height="49"
                  viewBox="0 0 57 49"
                  fill="none"
                >
                  <path
                    d="M25.8451 46.8817C24.7544 45.9392 23.8478 44.8261 22.9008 43.749C22.3622 43.1363 21.8034 42.5371 21.2559 41.9312C19.1554 39.6063 17.0571 37.2769 14.9521 34.9543C13.9131 33.8098 12.8517 32.6855 11.8171 31.5365C9.89616 29.4046 7.99539 27.257 6.07219 25.1273C4.94789 23.8818 3.76524 22.6857 2.66787 21.4156C1.92283 20.5561 1.03192 19.811 0.567385 18.7136C0.0602158 17.5175 0.18813 16.3641 0.78282 15.2846C3.0404 11.1802 5.34061 7.09588 7.62736 3.00487C8.22205 1.94116 8.7741 0.850518 10.0084 0.347837C10.5066 0.145867 10.998 0 11.5388 0C22.3196 0.00224411 33.1003 0.00224411 43.881 0C44.8347 0 45.6449 0.345593 46.3293 0.99863C46.6502 1.30383 46.9509 1.62923 47.2606 1.94789C47.2741 2.03765 47.2988 2.1162 47.4042 2.13639L47.3998 2.12966C47.3414 2.42588 47.5344 2.6301 47.6668 2.85675C50.1017 6.97245 52.5477 11.0837 54.9714 15.2083C55.8331 16.6715 55.7097 18.4825 54.6662 19.6876C53.5082 21.0251 52.3099 22.3312 51.1205 23.6417C49.1726 25.7893 47.2135 27.928 45.2701 30.0778C42.0049 33.6886 38.7465 37.3084 35.4835 40.9191C34.0002 42.5618 32.4831 44.1753 31.0245 45.8382C29.9383 47.077 28.648 47.6156 27.0165 47.2834C26.6709 47.2139 26.3702 46.9872 25.9999 47.0186L26.0089 47.0254C25.955 46.9782 25.9034 46.9289 25.8495 46.8817H25.8451ZM27.6628 2.9712C22.4587 2.9712 17.2524 2.97794 12.0483 2.96447C11.4042 2.96447 10.9868 3.17317 10.6614 3.76113C8.32752 7.98904 5.96223 12.2012 3.6104 16.4179C3.12567 17.2864 3.14811 17.4525 3.79891 18.1728C4.85588 19.3398 5.91061 20.5089 6.96759 21.6759C13.6461 29.059 20.3245 36.4444 27.0053 43.8253C27.6807 44.5703 28.1273 44.5815 28.7669 43.8769C36.5181 35.3111 44.267 26.7431 52.0159 18.1728C52.6824 17.4367 52.6981 17.2684 52.1977 16.4224C49.7314 12.2439 47.2516 8.07207 44.8078 3.88007C44.4241 3.2203 43.9708 2.95774 43.2122 2.96223C38.0283 2.98691 32.8467 2.97569 27.6628 2.97569V2.9712Z"
                    fill="#EFEFEF"
                  />
                  <path
                    d="M25.9947 47.0186C26.365 46.9849 26.668 47.2116 27.0113 47.2834C28.6428 47.6155 29.9331 47.0769 31.0193 45.8382C32.478 44.1753 33.995 42.5596 35.4783 40.9191C38.7435 37.3061 41.9997 33.6886 45.2649 30.0778C47.2106 27.9279 49.1697 25.7893 51.1153 23.6417C52.3047 22.3289 53.5008 21.0251 54.661 19.6876C55.7045 18.4825 55.8279 16.6737 54.9662 15.2083C52.5426 11.0859 50.0987 6.97468 47.6616 2.85673C47.5292 2.63232 47.3362 2.42586 47.3946 2.12964C48.0992 2.54704 48.4134 3.27862 48.8039 3.93839C51.2141 7.9935 53.613 12.0553 56.0097 16.1172C57.1677 18.0785 56.9522 19.7504 55.4083 21.4537C49.8766 27.5554 44.356 33.6706 38.831 39.7791C36.6183 42.2252 34.4146 44.6825 32.1862 47.1151C30.3101 49.1617 27.6441 49.1079 25.9902 47.0231L25.9947 47.0186Z"
                    fill="#A7A7A7"
                  />
                  <path
                    d="M47.4034 2.13412C47.2979 2.11617 47.2732 2.03538 47.2598 1.94562C47.3069 2.00845 47.3563 2.07129 47.4034 2.13412Z"
                    fill="#A7A7A7"
                  />
                  <path
                    d="M25.8457 46.8817C25.9001 46.9292 25.9522 46.9791 26.0065 47.0266C25.9522 46.9791 25.9001 46.9292 25.8457 46.8817Z"
                    fill="#A7A7A7"
                  />
                  <path
                    d="M27.6621 2.97122C32.846 2.97122 38.0277 2.98244 43.2116 2.95776C43.9678 2.95327 44.4234 3.21808 44.8071 3.8756C47.2487 8.0676 49.7307 12.2394 52.197 16.4179C52.6952 17.264 52.6817 17.4323 52.0152 18.1683C44.2663 26.7364 36.5174 35.3044 28.7662 43.8724C28.1267 44.5793 27.6801 44.5681 27.0046 43.8208C20.3239 36.4399 13.6454 29.0545 6.96692 21.6714C5.90995 20.5045 4.85521 19.3353 3.79824 18.1683C3.14745 17.4502 3.12725 17.2819 3.60973 16.4135C5.96156 12.1968 8.32686 7.98457 10.6607 3.75666C10.9861 3.16871 11.4035 2.95776 12.0476 2.96C17.2517 2.97347 22.458 2.96674 27.6621 2.96674V2.97122ZM43.326 5.03805C43.2632 4.76876 43.05 4.79793 42.8525 4.79793C37.8953 4.80466 32.938 4.81364 27.9785 4.82037C27.9426 4.80466 27.9067 4.80466 27.8708 4.82037C22.6847 4.82037 17.4963 4.82037 12.3102 4.82037C11.9937 4.84506 11.9713 5.14352 11.8636 5.33652C9.74513 9.11111 7.63791 12.8902 5.53294 16.6715C5.44766 16.8219 5.24569 16.9565 5.38258 17.1809C5.50601 17.3358 5.6227 17.4951 5.7551 17.641C10.6899 23.1009 15.6247 28.5631 20.564 34.0185C22.945 36.6464 25.335 39.2652 27.7227 41.8886C27.8416 42.0794 27.9404 41.9986 28.0346 41.8662C28.1266 41.8056 28.2344 41.7629 28.3062 41.6844C29.6953 40.1404 31.0709 38.5853 32.4623 37.0436C35.4828 33.6976 38.5057 30.3539 41.5352 27.0146C43.9701 24.3307 46.4296 21.6692 48.8443 18.965C49.3537 18.3928 49.9663 17.9013 50.3456 17.2124C50.5723 16.9655 50.3254 16.8017 50.2267 16.6334C49.1495 14.7999 48.0656 12.9687 46.9749 11.1398C45.7609 9.10438 44.5401 7.07346 43.3238 5.04029L43.326 5.03805Z"
                    fill="#848484"
                  />
                  <path
                    d="M28.0386 41.8616C27.9443 41.9963 27.8456 42.0771 27.7266 41.8841C27.7423 41.6597 27.7042 41.4487 27.6369 41.2311C26.8559 38.7154 26.0884 36.1975 25.3097 33.6819C23.8353 28.9266 22.3408 24.1758 20.8933 19.4116C20.6577 18.6373 20.2493 17.8968 20.2919 17.0463L20.2852 17.053C25.3344 17.2864 30.3859 17.1136 35.4374 17.1697C35.4913 17.1764 35.5429 17.1832 35.5967 17.1899C35.195 18.5229 34.8001 19.8604 34.3872 21.1911C32.6031 26.9383 30.8056 32.681 29.0349 38.4326C28.6849 39.5682 28.2495 40.6835 28.0431 41.8616H28.0386Z"
                    fill="#8C8C8C"
                  />
                  <path
                    d="M20.2882 17.0485C20.2456 17.8968 20.654 18.6396 20.8896 19.4138C22.3371 24.1781 23.8339 28.9289 25.306 33.6841C26.0847 36.1998 26.8522 38.7199 27.6332 41.2333C27.7005 41.451 27.7387 41.6619 27.7229 41.8864C25.3375 39.263 22.9452 36.6463 20.5642 34.0185C15.6249 28.5631 10.6901 23.1009 5.75534 17.641C5.62293 17.4951 5.50624 17.3335 5.38281 17.1809C10.0304 17.1809 14.6802 17.1809 19.3277 17.1787C19.5611 17.1787 19.8192 17.2662 20.0189 17.0553L20.2882 17.0508V17.0485Z"
                    fill="#BABABA"
                  />
                  <path
                    d="M27.9902 41.9222C28.1967 40.7441 28.6792 39.5704 29.0293 38.4349C30.7999 32.6832 32.5996 26.9405 34.3815 21.1934C34.7944 19.8626 35.1871 18.5274 35.591 17.1921C38.4366 17.1876 41.2821 17.1787 44.1299 17.1809C46.2034 17.1809 48.277 17.2011 50.3506 17.2101C49.9736 17.899 49.3609 18.3905 48.8493 18.9627C46.4346 21.6669 43.975 24.3284 41.5402 27.0124C38.5106 30.3516 35.4878 33.6953 32.4672 37.0413C31.0759 38.583 29.698 40.1359 28.3111 41.6821C28.2416 41.7607 28.0845 41.8639 27.9947 41.9222H27.9902Z"
                    fill="#F0F0F0"
                  />
                  <path
                    d="M20.2903 17.0485C20.2006 17.0485 20.1108 17.0507 20.021 17.053C19.2648 15.5068 18.2257 14.1334 17.3191 12.6792C15.6719 10.0446 13.9844 7.43919 12.3125 4.82031C17.4986 4.82031 22.687 4.82031 27.8732 4.82031C26.6546 6.77045 25.4293 8.71833 24.2153 10.6707C22.898 12.7936 21.5919 14.9233 20.2813 17.0507L20.2881 17.044L20.2903 17.0485Z"
                    fill="#8C8C8C"
                  />
                  <path
                    d="M20.2832 17.0552C21.5938 14.9278 22.8998 12.7982 24.2171 10.6752C25.429 8.72061 26.6542 6.77496 27.875 4.82483C27.9109 4.80912 27.9468 4.80912 27.9827 4.82483C30.476 8.85974 32.9669 12.8969 35.4601 16.9318L35.4354 17.1742C30.3862 17.1203 25.3325 17.2931 20.2832 17.0575V17.0552Z"
                    fill="#F4F4F4"
                  />
                  <path
                    d="M35.4579 16.9274C32.9646 12.8925 30.4737 8.85534 27.9805 4.82042C32.9377 4.81369 37.895 4.80472 42.8544 4.79798C43.0519 4.79798 43.2651 4.76881 43.3279 5.0381C43.1327 5.1144 43.0048 5.26027 42.8971 5.43307C40.7113 8.9249 38.53 12.4212 36.3263 15.9018C36.0907 16.2744 35.9605 16.7703 35.4579 16.9297V16.9274Z"
                    fill="#8C8C8C"
                  />
                  <path
                    d="M12.3137 4.82042C13.9856 7.4393 15.6732 10.047 17.3203 12.6793C18.2292 14.1312 19.266 15.5046 20.0222 17.0531C19.8225 17.2663 19.5644 17.1765 19.3311 17.1765C14.6835 17.181 10.0337 17.1787 5.38615 17.1787C5.24926 16.9543 5.45123 16.8219 5.5365 16.6693C7.64148 12.888 9.7487 9.10892 11.8671 5.33432C11.9749 5.14133 11.9995 4.84286 12.3137 4.81818V4.82042Z"
                    fill="#F1F4F5"
                  />
                  <path
                    d="M35.4563 16.9273C35.959 16.768 36.0892 16.272 36.3248 15.8995C38.5285 12.4189 40.7098 8.92257 42.8956 5.43073C43.0033 5.25793 43.1312 5.11207 43.3264 5.03577C44.545 7.06893 45.7658 9.09985 46.9776 11.1353C48.066 12.962 49.1499 14.7932 50.2293 16.6288C50.3281 16.7972 50.5749 16.961 50.3483 17.2078C48.2747 17.1966 46.2011 17.1809 44.1298 17.1787C41.2843 17.1764 38.4387 17.1854 35.591 17.1899C35.5371 17.1831 35.4855 17.1764 35.4316 17.1697C35.4406 17.0889 35.4473 17.0081 35.4563 16.9273Z"
                    fill="#CACACA"
                  />
                </svg>
                <p>هنوز امتیاز‌ی نگرفتی!</p>
              </div>
            )}
          </div>
        ) : (
          <div className="EmtiyazBashgah-inside-item3-bottom">
            {scoreHelpList.map((item) => (
              <ModalHelpCS
                img={"/imgs/Bashgah/bashgah-almas.svg"}
                title={` ${item.numberOfScore} امتیاز`}
                text={item.description}
              />
            ))}
          </div>
        )}
      </div>
    </Page>
  );
};
export default EmtiyazBashgah;
